export const ActionPopup = ({ action, visible }) => {
    if (!visible) return null;
  
    const getActionMessage = () => {
      switch (action) {
        case 'like':
          return 'You liked!';
        case 'dislike':
          return 'You disliked!';
        case 'match':
          return 'It\'s a match!';
        default:
          return '';
      }
    };
  
    return (
      <div className={`action-popup ${action}`}>
        <div className="popup-content">
          <div>{getActionMessage()}</div>
        </div>
      </div>
    );
  };
  